module.exports = __webpack_public_path__ + "img/2.c96e660a.png";